import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';

import { SessionContext } from "../context/session-context";

import getClients from "../functions/getClientList";
import getUsers from "../functions/getClientUsers";

import UserForm from "./UserForm";


const useStyles = makeStyles({
    root: {

    },
    selectContainer:{
        '& .MuiSelect-select.MuiSelect-select':{
            height: 'calc(100vh - 350px)',
        },
        marginTop:10,
        marginRight:10,
        border: '2px solid #3D3E4F',
    },
    selectObject:{
        width:'100%'
    }

  });


export default function UserPanel(props) {
    const classes = useStyles();
  
    const [sState, sDispatch] = useContext(SessionContext);
    const [selectedClient, setSelectedClient] = useState([]);
    const [selectedClientID, setSelectedClientID] = useState([]);
    const [clientRows, setClientRows] = useState([]);
    const [filterStr, setFilterStr] = useState('');
    const [selectedUserID, setSelectedUserID] = useState([]);
    const [userRows, setUserRows] = useState([]);
    const [selectedUser, setSelectedUser] = useState([]);
    const [hasUpdateRequest, setHasUpdateRequest] = useState(false);

    const [severity, setSeverity] = useState('success');
    const [msg, setMsg] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);


    /**
     * First load
     */
    useEffect(() => {

        getClients(sDispatch);

    },[])

    /**
     * Listerner for client list.
     */
    useEffect(() => {
        if (sState.clientList.length > 0){
          setClientRows(sState.clientList);
        }
      },[sState.clientList])

      useEffect(() => {
        if (sState.userList.length > 0){
          setUserRows(sState.userList);

          //Refresh from user update request.
          if (hasUpdateRequest){
            setSeverity('success')
            setMsg('User has been updated.')
            setSnackOpen(true);
            setHasUpdateRequest(false);
          }
        }
      },[sState.userList])
    
    const refreshCompanyList = () => {
        getClients(sDispatch);
    }

    useEffect(() => {
        if (filterStr.length > 1){

            var filterArray = JSON.parse(JSON.stringify(sState.clientList));
    
            filterArray = filterArray.filter(function (c) {
                return c.companyname.charAt(0).toLowerCase() === filterStr.charAt(0).toLowerCase();
            });

            if (filterStr.length > 1)
                filterArray = filterArray.filter(function (c) {
                    return c.companyname.charAt(1).toLowerCase() === filterStr.charAt(1).toLowerCase();
            });

            if (filterStr.length > 2)
            filterArray = filterArray.filter(function (c) {
                return c.companyname.charAt(2).toLowerCase() === filterStr.charAt(2).toLowerCase();
            });

            if (filterStr.length > 3)
            filterArray = filterArray.filter(function (c) {
                return c.companyname.charAt(3).toLowerCase() === filterStr.charAt(3).toLowerCase();
            });
            setClientRows(filterArray);
        } 

    },[filterStr])

    const handleClearFilter = () => {
        setClientRows(sState.clientList);
    };

    const handleGetCompanyDetail = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        setSelectedClientID(value);
    }

    const handleGetUserDetail = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        setSelectedUserID(value);
    }

    useEffect(() => {
        for (let c of clientRows) {
            if (parseInt(c.companyid) === parseInt(selectedClientID)){
                setSelectedClient(c.companyname)
                break;
            }
        }  
        getUsers(selectedClientID, sDispatch);
    },[selectedClientID])

    useEffect(() => {

        for (let u of userRows) {
            if (parseInt(u.userid) === parseInt(selectedUserID)){
                setSelectedUser(u);
                break;
            }
        }  
    },[selectedUserID])

    const handleUpdateRequest = () => {
        setHasUpdateRequest(true);
    }
    
    const handleSnackClose=()=>{
        setSnackOpen(false);
    }


    return (
        <div className={classes.root}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackOpen}
                autoHideDuration={6000}
                onClose={handleSnackClose}
                TransitionComponent={Slide}
                TransitionProps={{ direction: 'down' }}
            >
                <Alert onClose={handleSnackClose} severity={severity}>
                {msg}
                </Alert>
            </Snackbar>
            <Grid container>
                <Grid item xs={12}>
                    <Box className={classes.formLabel} fontWeight="500" fontStyle="italic" fontSize={22} >User details</Box>
                </Grid>
                <Grid item xs={12}>
                <Box>
                    <TextField className={classes.textField} name="filter" label="Filter Clients List" size="small" margin="dense" variant="outlined" value={filterStr} onChange={e => setFilterStr(e.target.value)}/>
                    <Button className={classes.filterButton} variant="contained" onClick={handleClearFilter} >
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Clear filter</Box>
                    </Button>
                </Box>
                </Grid>
                <Grid item xs={3}>
                <Box className={classes.selectContainer}>
                    <Select
                    multiple
                    native
                    value={selectedClientID}
                    className={classes.selectObject}
                    onChange={handleGetCompanyDetail}
                    inputProps={{
                        id: 'select-multiple-native',
                    }}
                    >
                    {clientRows.map((item, i) => (
                        <option key={i} value={item.companyid}>
                            {item.status === 'active'?item.companyname:item.companyname+" (Disabled)"}
                        </option>
                    ))}
                    </Select>

                </Box>
                </Grid>
                <Grid item xs={3}>
                <Box className={classes.selectContainer}>
                    <Select
                    multiple
                    native
                    value={selectedUserID}
                    onChange={handleGetUserDetail}
                    className={classes.selectObject}
                    inputProps={{
                        id: 'select-multiple-native',
                    }}
                    >
                    {userRows.map((item) => (
                        <option key={item.userid} value={item.userid}>
                            {item.username}
                        </option>
                    ))}
                    </Select>

                </Box>
                </Grid>
                <Grid item xs={6}>
                    <UserForm user={selectedUser} updated={handleUpdateRequest} companyid={selectedClientID} companyname={selectedClient}/>
                </Grid>
            </Grid>
        </div>
    )
  };
